function MainWeb() {
}

MainWeb.fn = {
    init: function () {
        MainWeb.fn.web.call(this);
        MainWeb.fn.activeMainMenu.call(this);
        MainWeb.fn.cartFormChange.call(this);
        MainWeb.fn.scrollTop.call(this);
        MainWeb.fn.applyDiscountCode.call(this);
        MainWeb.fn.updateTotal.call(this);
    },

    web: function () {
        Number.prototype.format = function(n, x) {
            var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
            return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
        };

        $('#nkcsafw_product_data .nkcsafw_products_select:not(#nkcsafw-current-product) input[type="checkbox"]').change(function () {
            var id = jQuery(this).val();
            jQuery('#nkcsafw_product_data .nkcsafw_products ' + '.img-'+id).toggleClass('hide');
            MainWeb.fn.reloadItem();
        });

        $(document).on('click', '.showcoupon', function () {
            $('.woocommerce-form-coupon').slideToggle();
            $('#coupon_code').focus();
        });

        $('input[name="payment_method"], input[name="shipping_method"]').on('change', MainWeb.fn.updateTotal.bind(this));
    },

    activeMainMenu: function () {
        $("#menu-primary-menu li a").each(function () {
            var _url = location.href.toLowerCase();
            if (this.href.toLowerCase() == _url) {
                $("#menu-primary-menu li").removeClass("active");
                $(this).parent().addClass("active");
            }
        });
    },

    cartFormChange: function () {
        const numberFormat = new Intl.NumberFormat('vi-VN', {
            style: 'currency',
            currency: 'VND',
        });

        $(document).on('change', '.cart.add-to-cart', function () {
            if ($('.single_price').length) {
                var priceTmp = $('.single_price').data("price");
                if ($('.single_price').is(':checked')) {
                    priceTmp = $('.origin_price').data("price");
                }
                priceTmp = priceTmp * $('.input-number').val();
                var priceData = numberFormat.format(priceTmp);

                $(".product-price").find('.product-sale-price').text(priceData);
            }
        });
    },

    popupBookingGolf: function () {
        setTimeout(function() {
            $("#registermodal").modal("show");
        }, 12000);
    },

    scrollTop: function () {
        // // fade in #back-top
        // $(window).scroll(function () {
        //     if ($(this).scrollTop() > 180) {
        //         $('#scroll-top').fadeIn();
        //     } else {
        //         $('#scroll-top').fadeOut();
        //     }
        // });
        // scroll body to 0px on click
        $('#btn-to-top').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    },

    applyDiscountCode: function () {
        $(document).on('click', '#apply_coupon', function (event) {
            event.preventDefault();
            $('body').loading('toggle');

            var elem = $(this);
            if (elem.hasClass('disabled'))
                return false;

            toastr.options.closeButton = true;
            toastr.options.positionClass = 'toast-top-right';

            let data = {
                coupon_code: $("#coupon_code").val(),
                shipping_method: $('input[name="shipping_method"]:checked').val(),
                payment_method: $('input[name="payment_method"]:checked').val(),
            };

            $.ajax({
                url: elem.data('route'),
                type: "post",
                dataType: "json",
                data: data,
                beforeSend: function () {
                    elem.addClass('disabled');
                    elem.attr('disabled', 'disabled');
                },
                success: function (response) {
                    if (response.success == true) {
                        toastr.success(response.message);
                    }

                    elem.removeClass('disabled');
                    elem.removeAttr('disabled');

                    // Update cart totals
                    if (typeof response.data != 'undefined') {
                        const data = response.data;
                        const $cartTotals = $('#order_total_price');
                        if ($cartTotals.length) {
                            $cartTotals.text(data.total);
                        }

                        const $cartDiscount = $('#order_discount_price');

                        if ($cartDiscount.length) {
                            $cartDiscount.text(data.discount);
                        }
                    }

                    $('body').loading('toggle');

                    // setTimeout(function() {
                    //     window.location.reload();
                    // }, 1000);
                },
                error: function (response) {
                    var message = response.responseJSON.errors;

                    if (typeof message != 'undefined') {
                        $.each(message, function (index, value) {
                            toastr.error(value);
                        });
                    } else {
                         toastr.error(response.responseJSON.message);
                    }

                    elem.removeClass('disabled');
                    elem.removeAttr('disabled');

                    $('body').loading('toggle');
                }
            });

            return false;
        });
    },

    updateTotal: function () {
        let base = parseFloat($('#order_base_price').data('base') || 0);
        let paymentCost = parseFloat($('input[name="payment_method"]:checked').data('cost') || 0);
        let shippingCost = parseFloat($('input[name="shipping_method"]:checked').data('cost') || 0);
        let discount = parseFloat($('#order_discount').data('discount') || 0);
        let finalTotal = base + paymentCost + shippingCost - discount;
        $('#order_total_price').text(finalTotal.toLocaleString('vi-VN', {
            style: 'currency',
            currency: 'VND'
        }));

        $('#order_discount_price').text(discount.toLocaleString('vi-VN', {
            style: 'currency',
            currency: 'VND'
        }));
    },

    rule: function () {
        $(document).ready(function () {
            MainWeb.fn.init.call(this);

            $(document).on('click', '.modal-overlay', function (e) {
                $('.mobile-menu-toggler').trigger('click');
            });

            $(document).on('change', '.select-option', function (e) {
               $("#modal-alert").modal("show").attr('id', 'modal-alert-changed')
               // alert('Lựa chọn của golfer sẽ làm thay đổi giá của sản phẩm. Skygolf sẽ liên hệ lại khi thanh toán đơn hàng.');
           });
        });
    },
};

MainWeb.fn.rule();
